import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './home-page/login/login.component';
import { BidderRegistrationComponent } from './home-page/bidder-registration/bidder-registration.component';
import { PaymentResponseComponent } from './home-page/payment-response/payment-response.component';


const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'BidderReg', component: BidderRegistrationComponent },
  { path: 'PrintReceipt', component: PaymentResponseComponent },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'bidder', loadChildren: () => import('./bidder/bidder.module').then(m => m.BidderModule) },
  { path: 'DA', loadChildren: () => import('./da/da.module').then(m => m.DAModule) },
  { path: 'LDCRO', loadChildren: () => import('./ldcro/ldcro.module').then(m => m.LDCROModule) },
  { path: 'DC', loadChildren: () => import('./dc/dc.module').then(m => m.DCModule) },
  {path: '**', redirectTo: '/'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
